import NormalModal from '../../normal-modal';
import { memo, useEffect, useRef, useState } from 'react';
import { FeedBackSTatus } from '../../../constants/constants';
import PauseIconComponent from './pause-icon-component';
import tw from 'twin.macro';
import CreatorSection from './creator-section';
import UserSection from './user-section';
import CounterAfterFeedBackFinish from './counterafter-finish-feedback';
import { exercisesStats } from '../../../reducers/exercises-reducer';

const PauseContainerModal = 'bg-[rgba(0,0,0,0)] flex justify-center items-center overflow-hidden';
const feedBackContainerModal = 'w-[90vw] h-[82vh] px-4 pt-2 pb-2 rounded-[20px] overflow-hidden';

const FeedBackModal = ({
  open,
  handleClose,
  movementName,
  videoSrc,
  feedBackUserVideoRef,
  playVideo,
  feedbackResultTurn,
  setCanPlay,
  videoRecordSrc,
  setHasError,
  isPlayFeedBacvoice,
  setFeedbackResultTurn,
  setISFinishVideoForNextTurn2,
  setCreatorDuration,
  dispatch,
}) => {
  const hideNumber = localStorage.getItem('hideNumber');
  const [showPauseIcon, setShowPauseIcon] = useState(true);
  const [progress, setProgress] = useState(1);
  const [feedBackprogress, setFeedBackProgress] = useState(1);
  const [isPlayingFeed, setIsPlayingFeedback] = useState(false);
  const [counter, setCounter] = useState(hideNumber ? 0 : 3);
  const hiddenVideoPlayerRef = useRef(null);
  const [showCounter, setShowCouter] = useState(false);
  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    if (showPauseIcon && open) {
      setTimeout(() => {
        setShowPauseIcon(false);
      }, 2000);
    }
  }, [showPauseIcon, open]);

  useEffect(() => {
    if (counter > 0 && showCounter) {
      setTimeout(() => {
        setCounter(prev => prev - 1);
      }, 1000);
    }
    if (counter === 0) {
      setShowCouter(false);
      localStorage.setItem('hideNumber', true);
    }
  }, [counter, showCounter]);

  useEffect(() => {
    if (feedBackUserVideoRef?.current && playVideo?.feed_back_video) {
      setIsPlayingFeedback(true);
      setISFinishVideoForNextTurn2(false);
      setTimeout(
        () => {
          setIsPlayingFeedback(false);
          feedBackUserVideoRef.current.pause();
          setISFinishVideoForNextTurn2(true);
        },
        (playVideo.feed_back_video.to - playVideo.feed_back_video.from) *
          (1 / playVideo.feed_back_video.speed) *
          1000
      );
    }
  }, [feedBackUserVideoRef, playVideo?.feed_back_video?.to]);

  // reset states and variables
  useEffect(() => {
    if (feedbackResultTurn === 5 && !isPlayFeedBacvoice && counter === 0) {
      dispatch({ type: exercisesStats.stopSend, payload: true });
      setHasError(false);
      setFeedbackResultTurn(-1);
      setProgress(1);
      setFeedBackProgress(1);
      setCanPlay(false);
      setISFinishVideoForNextTurn2(false);
      localStorage.setItem('is_feed_back_finished', FeedBackSTatus.SET_IS_FINISHING);
    }
  }, [counter, feedbackResultTurn, isPlayFeedBacvoice]);

  useEffect(() => {
    if (feedbackResultTurn === 5) {
      setShowCouter(true);
    }
  }, [feedbackResultTurn]);

  return (
    <NormalModal
      open={true}
      modalStyle={{ justifyContent: 'inherit', paddingTop: '2%', zIndex: 10 }}
      containerModalStyle={
        showPauseIcon || showCounter ? tw`${PauseContainerModal}` : tw`${feedBackContainerModal}`
      }
      hideIcon
      handleClose={handleClose}
      backgroundModal="rgba(0,0,0,0.3)"
      content={
        <div>
          {feedbackResultTurn === 5 && showCounter && (
            <CounterAfterFeedBackFinish counter={counter} />
          )}
          {showPauseIcon && (
            <PauseIconComponent
              hiddenVideoPlayerRef={hiddenVideoPlayerRef}
              videoRecordSrc={videoRecordSrc}
              playVideo={playVideo}
              setImageUrl={setImageUrl}
              showPauseIcon={showPauseIcon}
            />
          )}
          {!showPauseIcon && !showCounter && (
            <div tw="grid grid-cols-2 justify-center h-[79vh] overflow-hidden">
              <CreatorSection
                movementName={movementName}
                playVideo={playVideo}
                progress={progress}
                setCanPlay={setCanPlay}
                setCreatorDuration={setCreatorDuration}
                setIsPlayingFeedback={setIsPlayingFeedback}
                setProgress={setProgress}
                videoSrc={videoSrc}
              />
              <UserSection
                feedBackUserVideoRef={feedBackUserVideoRef}
                feedBackprogress={feedBackprogress}
                feedbackResultTurn={feedbackResultTurn}
                isPlayingFeed={isPlayingFeed}
                playVideo={playVideo}
                setFeedBackProgress={setFeedBackProgress}
                setIsPlayingFeedback={setIsPlayingFeedback}
                videoRecordSrc={videoRecordSrc}
                imageUrl={imageUrl}
              />
            </div>
          )}
        </div>
      }
    />
  );
};
export default memo(FeedBackModal);
